import { defineMessages } from "react-intl";

export default defineMessages({
  belowMinimum: {
    id: "hoursWorkedInput.belowMinimum",
    defaultMessage: "Ne peut pas être inférieur à {min}",
  },
  invalid: {
    id: "hoursWorkedInput.invalid",
    defaultMessage: "Indiquez une durée valide, par exemple 01:30",
  },
});
